(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-style-option"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-card-style-option]');
    if (!option || option.disabled || option.getAttribute('aria-disabled') === 'true') return;

    const card = option.closest('.product-card-wrapper');
    const price = card?.querySelector('[data-card-style-price]');
    const priceData = price?.querySelector('[data-card-style-prices]');
    if (!priceData) return;

    let prices;
    try {
      prices = JSON.parse(priceData.textContent);
    } catch {
      return;
    }
    const selectedPrice = prices[option.dataset.priceKey];
    if (typeof selectedPrice !== 'string') return;

    event.preventDefault();
    event.stopPropagation();
    const variantGroups = card.querySelectorAll('[data-card-style-variants]');
    let selectedVariantId = option.dataset.variantId;
    variantGroups.forEach((group) => {
      const active = group.dataset.cardStyleVariants === option.dataset.productHandle;
      const buttons = group.querySelectorAll('[data-card-style-option]');
      group.hidden = !active || !buttons.length;
      group.style.display = group.hidden ? 'none' : '';
      if (active && !selectedVariantId) {
        selectedVariantId = Array.from(buttons).find((button) =>
          button.dataset.priceKey === option.dataset.priceKey
        )?.dataset.variantId;
      }
    });
    const template = document.createElement('template');
    template.innerHTML = selectedPrice;
    price.replaceChildren(template.content, priceData);
    if (option.dataset.variantUrl) {
      card.querySelectorAll('a.card-information_style-lin, a.product-button, a.card__heading_a').forEach((link) => {
        link.setAttribute('href', option.dataset.variantUrl);
      });
    }
    const savings = price.querySelector('.price-item--save');
    card.querySelectorAll('.badge_off').forEach((badge) => {
      badge.hidden = !savings;
      if (savings) badge.textContent = savings.textContent.trim();
    });

    card.querySelectorAll('[data-card-style-option]').forEach((button) => {
      const selected = button.dataset.productHandle === option.dataset.productHandle &&
        (!button.dataset.variantId || button.dataset.variantId === selectedVariantId);
      button.classList.toggle('current', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs-banner-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tabs-banner-slider')) {
    customElements.define('tabs-banner-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.tabs-banner-slider__track');
        this.viewport = this.querySelector('.tabs-banner-slider__viewport');
        this.slides = Array.from(this.track.children);
        this.count = this.slides.length;
        if (!this.count) return;
        this.abort = new AbortController();
        const on = (target, event, callback) => target.addEventListener(event, callback, { signal: this.abort.signal });
        this.index = this.count > 1 ? this.count : 0;
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reducedMotion = this.paused;
        if (this.count > 1) {
          const copy = () => this.slides.map(slide => {
            const clone = slide.cloneNode(true);
            clone.dataset.clone = '';
            clone.inert = true;
            clone.setAttribute('aria-hidden', 'true');
            return clone;
          });
          this.track.prepend(...copy());
          this.track.append(...copy());
          this.querySelector('.tabs-banner-slider__controls').hidden = false;
          on(this.querySelector('[data-prev]'), 'click', () => this.move(-1));
          on(this.querySelector('[data-next]'), 'click', () => this.move(1));
          on(this.viewport, 'keydown', event => {
            if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            event.preventDefault();
            this.move(event.key === 'ArrowLeft' ? -1 : 1);
          });
          on(this.viewport, 'pointerdown', event => { this.pointer = { x: event.clientX, y: event.clientY }; });
          on(this.viewport, 'pointerup', event => {
            if (!this.pointer) return;
            const dx = event.clientX - this.pointer.x;
            const dy = event.clientY - this.pointer.y;
            this.pointer = null;
            this.swiped = Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy);
            if (this.swiped) this.move(dx < 0 ? 1 : -1);
          });
          on(this.viewport, 'pointercancel', () => { this.pointer = null; });
          on(this.viewport, 'click', event => { if (this.swiped) { event.preventDefault(); this.swiped = false; } });
          on(this.track, 'transitionend', event => { if (event.target === this.track) this.settle(); });
          on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
          on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
          on(this, 'focusin', () => { this.focused = true; this.schedule(); });
          on(this, 'focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
          on(document, 'visibilitychange', () => this.schedule());
          const pause = this.querySelector('[data-pause]');
          if (pause) {
            const update = () => { pause.textContent = this.paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label', this.paused ? pause.dataset.playLabel : pause.dataset.pauseLabel); };
            on(pause, 'click', () => { this.paused = !this.paused; update(); this.schedule(); });
            update();
          }
        }
        this.resize = new ResizeObserver(() => { this.settle(); this.schedule(); });
        this.resize.observe(this.viewport);
        this.position(false);
        this.schedule();
      }
      position(animate) {
        const width = this.slides[0].getBoundingClientRect().width;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.style.transition = animate && !this.reducedMotion ? 'transform 450ms ease' : 'none';
        this.track.style.transform = `translateX(${(this.viewport.clientWidth - width) / 2 - this.index * (width + gap)}px)`;
        const active = this.count > 1 ? (this.index % this.count + this.count) % this.count : 0;
        this.slides.forEach((slide, index) => { slide.inert = index !== active; slide.setAttribute('aria-hidden', String(index !== active)); });
      }
      move(direction) {
        if (this.moving || this.count < 2) return;
        this.moving = true;
        this.index += direction;
        this.position(true);
        clearTimeout(this.finishTimer);
        this.finishTimer = setTimeout(() => this.settle(), this.reducedMotion ? 0 : 500);
        this.schedule();
      }
      settle() {
        clearTimeout(this.finishTimer);
        if (this.count > 1) this.index = this.count + ((this.index % this.count) + this.count) % this.count;
        this.position(false);
        this.moving = false;
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.count < 2 || this.paused || this.hovered || this.focused || document.hidden || !this.viewport.clientWidth) return;
        this.timer = setTimeout(() => { this.move(1); }, Number(this.dataset.interval) || 5000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.finishTimer);
        this.abort?.abort();
        this.resize?.disconnect();
        this.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tabs-content-card-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tabs-content-card-slider')) {
    customElements.define('tabs-content-card-slider', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.tabs-content-cards__viewport');
        this.cards = Array.from(this.viewport.children);
        this.controls = this.querySelector('.tabs-content-cards__controls');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.querySelector('[data-card-prev]').addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-card-next]').addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.viewport);
        if (this.cards[0]) this.resize.observe(this.cards[0].querySelector('.tabs-content-cards__image'));
        this.update();
      }
      update() {
        this.controls.hidden = this.viewport.scrollWidth <= this.viewport.clientWidth + 2;
        const image = this.cards[0]?.querySelector('.tabs-content-cards__image');
        if (image) this.style.setProperty('--card-arrow-top', `${image.getBoundingClientRect().height / 2}px`);
      }
      move(direction) {
        if (!this.cards.length || !this.viewport.clientWidth) return;
        const max = this.viewport.scrollWidth - this.viewport.clientWidth;
        const current = this.viewport.scrollLeft;
        const step = this.cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.viewport).gap) || 0);
        let target = Math.max(0, Math.min(max, current + direction * step));
        if (direction > 0 && current >= max - 2) target = 0;
        if (direction < 0 && current <= 2) target = max;
        this.viewport.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
